@if (vm$ | async; as vm) {
@if (vm.visible) {
<div ngbDropdown class="language-selector" display="dynamic" placement="bottom-end">
  <button type="button" class="lang-toggle" ngbDropdownToggle [attr.aria-label]="'language' | translate">
    @if (vm.current?.countryCode) {
    <span class="fi fi-{{ vm.current!.countryCode }} flag"></span>
    }
    <span class="lang-name">{{ vm.current?.nativeName ?? vm.current?.isoCode ?? '' }}</span>
    <i class="ri-arrow-down-s-line chevron"></i>
  </button>
  <div ngbDropdownMenu class="lang-menu">
    @for (lang of vm.languages; track lang.isoCode) {
    <button type="button" ngbDropdownItem class="lang-item" [class.active]="lang.isoCode === vm.current?.isoCode"
      (click)="select(lang.isoCode)">
      @if (lang.countryCode) {
      <span class="fi fi-{{ lang.countryCode }} flag"></span>
      }
      <span class="lang-name">{{ lang.nativeName }}</span>
      @if (lang.isoCode === vm.current?.isoCode) {
      <i class="ri-check-line check"></i>
      }
    </button>
    }
  </div>
</div>
}
}
